import React from "react";

import PortfolioPlanList from "@src/multiCustodian/components/Advisor/Investments/ModelMarketplaceV2/PortfolioPlanList";

const ModelMarketplaceV2: React.FC = () => {
  return <PortfolioPlanList />;
};

export default ModelMarketplaceV2;
